import request from "@/utils/request";

export function getGroupReturnVisitClients(params){
  return request({
    url: "/worktop/groupreturnvisitclients",
    method: "get",
    params:params
  });
}

export function getGroupUnReturnVisitOrders(params){
  return request({
    url: "/worktop/getgroupunreturnvisitorders",
    method: "get",
    params:params
  });
}

export function getGroupPreOrderData(params){
  return request({
    url: "/worktop/getgrouppreorderdata",
    method: "get",
    params:params
  });
}

export function getTomorrowTasks(params){
  return request({
    url: "/worktop/tomorrowtasks",
    method: "get",
    params:params
  });
}
export function getReturnVisitClients(params){
  return request({
    url: "/worktop/returnvisitclients",
    method: "get",
    params:params
  });
}
export function getReturnVisitOrders(params) {
  return request({
    url: "/worktop/returnvisitorders",
    method: "get",
    params:params
  });
}
export function getUndispatchedTasks(params) {
  return request({
    url: "/worktop/undispatchedtasks",
    method: "get",
    params:params
  });
}

export function getSellerUncollectedOrders(params) {
  return request({
    url: "/worktop/uncollectedorders",
    method: "get",
    params:params
  });
}
